import EmailIcon from '@mui/icons-material/Email';
import { Box, Button, Stack, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { get } from 'lodash';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingBackdrop from '../../../../components/ui-component/loading/LoadingBackdrop';
import { MeinBereichPaper } from '../../../../components/ui-component/mein-bereich/MeinBereichComponents';
import { useFetchnachrichtenStartSeite } from '../../../../hooks/FetchNachrichten';
import { PAGES_URLS } from '../../../../lib/constants/routes';
import { DisplayDateTime } from '../../../../utils/formats';

// import schemas
import Schema from '../../../../lib/paths/portal45nachricht_TABLE_Paths.json';
let P = Schema.attributes;

function Nachrichten() {
	const navigate = useNavigate();
	const { loading, error, data } = useFetchnachrichtenStartSeite();

	const anzahlWeiteNachricht = useMemo(() => {
		return parseInt(get(data, 'meta.pagination.total', '0')) - 2;
	}, [data]);

	if (error) console.error('ERROR Fetching Nachrichten', error);
	if (loading) return <LoadingBackdrop />;

	const RenderNachrichten = () => {
		if (!data || !Array.isArray(data) || data.length === 0) {
			return <div>Keine neuen Nachrichten</div>; // Fallback für leere oder ungültige Daten
		}

		return (
			<>
				{data?.map((ele, i) => (
					<Box key={i} sx={{ bgcolor: 'common.white', padding: '1rem' }}>
						<Stack spacing={1} alignItems={'stretch'}>
							<Stack direction={'row'} justifyContent={'space-between'}>
								<Typography variant={'subtitle2'} sx={{ fontWeight: 500 }}>
									{get(ele, P.Allgemein_Betreff.path)}
								</Typography>
							</Stack>

							<Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
								<Typography variant={'caption'}>Erstellt am: {DisplayDateTime(get(ele, 'attributes.createdAt'))}</Typography>
								<Button variant={'text'} onClick={() => navigate(`${PAGES_URLS.NachrichtenDetails}`, { state: { id: get(ele, 'id') } })}>
									Ansehen
								</Button>
							</Stack>
						</Stack>
					</Box>
				))}
			</>
		);
	};

	return (
		<>
			<MeinBereichPaper title='Nachrichten' titleIcon={<EmailIcon sx={{ color: 'black' }} />}>
				<RenderNachrichten />
				<Box>
					{get(data, 'meta.pagination.total', -1) > 2 && (
						<Grid2 sm={1} lg={12}>
							<Typography
								sx={{ textDecoration: 'underline !important', color: 'primary.main', cursor: 'pointer' }}
								onClick={() => {
									navigate(PAGES_URLS.Nachrichten);
								}}
							>{`+ ${anzahlWeiteNachricht} weitere`}</Typography>
						</Grid2>
					)}
				</Box>
			</MeinBereichPaper>
		</>
	);
}

export default Nachrichten;
